import { UserAbility } from './UserAbility.js';

/**
 * Clinic products and the abilities each one enables.
 * Matches com.medprompt.shared.identity.Product
 */
export const Product = {
  DOCUMENTS: {
    key: 'DOCUMENTS',
    abilities: [
      UserAbility.DOCS_READ.key,
      UserAbility.DOCS_READ_ALL.key,
      UserAbility.DOCS_WRITE.key
    ]
  },
  SCRIBE: {
    key: 'SCRIBE',
    abilities: [
      UserAbility.CONSULT_READ.key,
      UserAbility.CONSULT_READ_ALL.key,
      UserAbility.CONSULT_WRITE.key
    ]
  }
};

const TASK_ABILITIES = [
  UserAbility.TASK_READ.key,
  UserAbility.TASK_WRITE.key
];

/**
 * Role abilities minus those belonging to products the target clinic does not have.
 * Missing clinic / missing map is treated as no products (fail closed).
 */
export const getEffectiveAuthorities = (roleAuthorities, clinicProducts, clinicId) => {
  if (!Array.isArray(roleAuthorities)) {
    return [];
  }

  const availableProducts = new Set(clinicProducts?.[clinicId] || []);
  const excludedAbilities = new Set();

  Object.values(Product).forEach((product) => {
    if (availableProducts.has(product.key)) {
      return;
    }
    product.abilities.forEach((ability) => excludedAbilities.add(ability));
  });

  if (!availableProducts.has(Product.DOCUMENTS.key) && !availableProducts.has(Product.SCRIBE.key)) {
    TASK_ABILITIES.forEach((ability) => excludedAbilities.add(ability));
  }

  return roleAuthorities.filter((ability) => !excludedAbilities.has(ability));
};

/**
 * True when the clinic has every product the role requires.
 * Empty requiredProducts means the role is visible everywhere.
 */
export const clinicMeetsRequiredProducts = (requiredProducts, clinicProducts) => {
  const required = requiredProducts || [];
  if (required.length === 0) {
    return true;
  }
  const available = new Set(clinicProducts || []);
  return required.every((product) => available.has(product));
};

export const filterRolesByClinicProducts = (roles, clinicProducts) => {
  return Object.fromEntries(
    Object.entries(roles || {}).filter(([, roleData]) =>
      clinicMeetsRequiredProducts(roleData.requiredProducts, clinicProducts)
    )
  );
};
